/**
* @name: import-done-datas
* @author: weiyong
* @date: 2023-12-11 00:13
* @description：import-done-datas
* @update: 2023-12-11 00:13
*/
<template>
  <div class="import-done-datas" style="margin-top: 12px;">
    <div class="data-item-content">
      <excel-grid-show :columns="columns"
                       :windowHeight="windowHeight"
                       @prePage="prePage"
                       @nextPage="nextPage"
                       v-if="excelGridFlag" :records="records"></excel-grid-show>
      <import-result-show v-else  :records="records"/>
    </div>
    <div class="data-total">总共 <span style="color:var(--primary-color,#0a6eff)">{{records.length}}</span> 条记录</div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "import-done-datas",
});
</script>

<script lang="ts" setup>
import ImportResultShow from "@/main-page/components/import-result-show.vue";
import ExcelGridShow from "@/main-page/components/excel-grid-show.vue";
interface propsType{
  windowHeight:number,
  excelGridFlag:boolean,
  columns:any,
  records:any,
}
const propsDef = withDefaults(defineProps<propsType>(),{
  excelGridFlag:false,
  windowHeight:550,
  columns:[],
  records: {},
});

const emits=defineEmits(['prePage','nextPage'])
const prePage=function (){
  emits('prePage',{})
}
const nextPage=function (){
  emits('nextPage',{})
}
</script>

<style type="text/css" lang="less">
.import-done-datas{
  min-height:400px;
  padding: 0 22px 20px 40px;
  flex: 1;
  display: flex;
  flex-direction: column;

  .data-total {
    width: 100%;
    display: flex;
    align-items: end;
    margin-top: 10px;
  }
  .data-item-content {
    flex: 1;
    overflow: auto;
  }
}
</style>
